export default {"src":"/_next/static/media/auth2.dd2634d3.svg","height":139,"width":139,"blurWidth":0,"blurHeight":0};